import { AACValidateProfileError } from 'model';

export const AAC_PROFILE_NOT_FOUND_ERROR: AACValidateProfileError = {
  title: 'Participant profile not found',
  description:
    "It looks like we couldn't find your profile in our records. Please reach out to our on-site assistant for assistance or try again.",
  fieldMessage: 'Profile not found'
};

// Instructors validate with their B3 email and must be assigned to the session (BU-22028)
export const AAC_INSTRUCTOR_NOT_FOUND_ERROR: AACValidateProfileError = {
  title: 'Unable to check-in',
  description:
    'Your email address could not be found, or you may not be assigned as an instructor for this activity. Please contact the on-site assistant for assistance.',
  fieldMessage: 'Email not found'
};

// Validate profile error responses that go to the retry screen
export const AAC_VALIDATE_PROFILE_ERRORS: Record<number, AACValidateProfileError> = {
  400: AAC_PROFILE_NOT_FOUND_ERROR,
  404: AAC_PROFILE_NOT_FOUND_ERROR,
  409: {
    title: 'Already checked in to an overlapping session',
    description:
      'It looks like this client is already checked into another session at this time. Please reach out to our on-site assistant for assistance or try again.',
    fieldMessage: 'Client is already checked into an overlapping session at this time.'
  }
};
